var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLegacyHeartUnpressed = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.01 26.63c-.26 0-.51-.11-.7-.29L2.35 15.21c-3.14-3.18-3.14-8.38 0-11.59a7.956 7.956 0 0 1 5.72-2.41c2.17 0 4.21.85 5.74 2.4l.19.2.19-.19a8.02 8.02 0 0 1 5.73-2.4c2.17 0 4.21.85 5.73 2.4 3.13 3.21 3.13 8.41 0 11.6L14.71 26.34a.95.95 0 0 1-.7.29M8.07 3.17c-1.64 0-3.17.65-4.32 1.82-2.39 2.45-2.4 6.42 0 8.85l10.27 10.43 10.24-10.41c2.39-2.44 2.39-6.41 0-8.86a6.035 6.035 0 0 0-4.33-1.82c-1.63 0-3.17.65-4.34 1.82l-.88.9c-.37.37-1.02.37-1.39 0l-.89-.9a6.066 6.066 0 0 0-4.36-1.83"
  })));
};
export default SvgLegacyHeartUnpressed;